import React from 'react';

interface MicrosoftAuthButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export const MicrosoftAuthButton: React.FC<MicrosoftAuthButtonProps> = ({ 
  onClick, 
  disabled = false, 
  className = '' 
}) => {
  const handleClick = (e: React.MouseEvent) => {
    console.log('=== MICROSOFT BUTTON DEBUG ===');
    console.log('MicrosoftAuthButton clicked!');
    console.log('Event:', e);
    console.log('onClick function exists:', !!onClick);
    console.log('Button disabled:', disabled);
    
    if (onClick) {
      console.log('Calling onClick function...');
      onClick();
      console.log('onClick function called');
    } else {
      console.log('No onClick function provided!');
    }
  };

  return (
    <button
      type="button" // Explicitly set type to button
      onClick={handleClick}
      disabled={disabled}
      className={`w-full flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {/* Microsoft Logo SVG */}
      <svg
        className="w-5 h-5 mr-2"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zM24 11.4H12.6V0H24v11.4z"/>
      </svg>
      Continue with Microsoft
    </button>
  );
};
